import { useTranslation } from "react-i18next";
import { FORM_CONTROL_CLASS } from "../../ui/styles/formStyles";
import Field from "../../ui/forms/Field";

interface NewPasswordFieldsProps {
  idPrefix: string;
  password: string;
  confirmation: string;
  onPasswordChange: (password: string) => void;
  onConfirmationChange: (confirmation: string) => void;
}

/** A new password, typed twice. The server checks its length; the app only compares the two. */
export default function NewPasswordFields({
  idPrefix,
  password,
  confirmation,
  onPasswordChange,
  onConfirmationChange,
}: NewPasswordFieldsProps) {
  const { t } = useTranslation();

  return (
    <>
      <Field id={`${idPrefix}-password`} label={t("newAccount.password")}>
        {(control) => (
          <input
            {...control}
            type="password"
            className={`mb-3 ${FORM_CONTROL_CLASS}`}
            value={password}
            onChange={(event) => {
              onPasswordChange(event.target.value);
            }}
            autoComplete="new-password"
            required
          />
        )}
      </Field>
      <Field id={`${idPrefix}-confirmation`} label={t("newAccount.confirmPassword")}>
        {(control) => (
          <input
            {...control}
            type="password"
            className={`mb-3 ${FORM_CONTROL_CLASS}`}
            value={confirmation}
            onChange={(event) => {
              onConfirmationChange(event.target.value);
            }}
            autoComplete="new-password"
            required
          />
        )}
      </Field>
    </>
  );
}
